import { Reveal, SectionHeading } from "./Reveal";
import { BadgePercent, Phone } from "lucide-react";

export const Promotions = ({ promotions = [], hotel }) => {
  if (!promotions.length) return null;
  return (
    <section id="promotions" className="bg-[#EFEBE1] py-20 md:py-28 relative overflow-hidden" data-testid="promotions-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-14">
          <SectionHeading eyebrow="Limited Time" title="Offers & Seasonal Rates" testId="promotions" />
        </div>
        <div className="grid sm:grid-cols-2 gap-6">
          {promotions.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <div
                className="relative bg-[#0A192F] rounded-2xl p-7 sm:p-9 overflow-hidden group hover:shadow-2xl transition-shadow duration-500"
                data-testid={`promotion-card-${p.id}`}
              >
                <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-[#C5A059]/15 blur-2xl group-hover:bg-[#C5A059]/25 transition-colors duration-700" />
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <span className="inline-flex items-center gap-2 text-[#C5A059] text-xs font-semibold uppercase tracking-[0.25em]">
                      <BadgePercent size={14} /> {p.discount}
                    </span>
                    <h3 className="font-serif-display text-2xl sm:text-3xl font-semibold text-[#F8F6F0] mt-3">{p.title}</h3>
                    <p className="text-[#F8F6F0]/65 text-sm leading-relaxed mt-3">{p.description}</p>
                    {(p.valid_from || p.valid_to) && (
                      <p className="text-[#F8F6F0]/45 text-xs mt-4">
                        Valid {p.valid_from} → {p.valid_to}
                      </p>
                    )}
                  </div>
                </div>
                <div className="mt-6 flex flex-wrap items-center gap-3">
                  <span className="font-mono text-sm tracking-widest text-[#0A192F] bg-[#C5A059] rounded-lg px-4 py-2 font-semibold" data-testid={`promotion-code-${p.id}`}>
                    {p.code}
                  </span>
                  <a
                    href={hotel?.phone_href || "tel:+13346870000"}
                    className="text-sm font-medium text-[#F8F6F0] border border-[#F8F6F0]/25 hover:border-[#C5A059] hover:text-[#C5A059] rounded-full px-5 py-2 transition-all flex items-center gap-2"
                    data-testid={`promotion-call-${p.id}`}
                  >
                    <Phone size={14} /> Mention code when calling
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
